import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
//bootstrap
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
//router
import { RouterModule, Routes } from '@angular/router';
import {ReactiveFormsModule,FormsModule} from '@angular/forms';
import {FormlyModule} from '@ngx-formly/core';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NavbarComponent } from './navbar/navbar.component';
import { ServicesListComponent } from './services-list/services-list.component';
import { QualifyProductComponent } from './qualify-product/qualify-product.component';
// Import HttpClientModule from @angular/common/http
import {HttpClientModule} from '@angular/common/http';
import { Urls } from "./urls";
import { PlaceholderFieldsService } from './placeholder-fields.service';
import { NewServiceComponent } from './new-service/new-service.component';
import { ThrowawayComponent } from './throwaway/throwaway.component';
@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    ServicesListComponent,
    QualifyProductComponent,
    NewServiceComponent,
    ThrowawayComponent,
  ],
  imports: [
    BrowserModule,
    NgbModule.forRoot(),
    ReactiveFormsModule,
    FormlyModule.forRoot(),
    FormlyBootstrapModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule
  ],
  providers: [Urls, PlaceholderFieldsService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/sachinmacbook/Sites/ngfront/src/app/app.module.ts